<template>
    <div class="Layout">
        <web-nav ref="webNav"></web-nav>
        <div class="main-container" :style="{minHeight: browserHeight-250-100+'px'}">
            <div class="menuList">
                <el-menu :default-active="activeName" class="el-menu-demo" active-text-color="#FF7D00" @select="handleSelect">
                    <el-menu-item index="/personalCenter">
                        <template slot="title">
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/personInfo.png">
                            <span>个人信息</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/followWith">
                        <template slot="title">
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/attention.png">
                            <span>关注</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/commentOfMe">
                        <template slot="title">
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/commentOfMy.png">
                            <span>评论我</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/myComment">
                        <template slot="title">
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/myComment.png">
                            <span>我评论</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/myOrderList">
                        <template>
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/order.png">
                            <span>我的订单</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/address">
                        <template>
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/address.png">
                            <span>收获地址</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/paymentMethod">
                        <template>
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/paymentMethod.png">
                            <span>收款方式</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/notice">
                        <template>
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/notice.png">
                            <span>通知</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/myCoupons">
                        <template>
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/myCoupons.png">
                            <span>我的优惠券</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/myInvitation">
                        <template>
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/invitation.png">
                            <span>我的邀请</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/service">
                        <template>
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/service.png">
                            <span>客服</span>
                        </template>
                    </el-menu-item>
                    <el-menu-item index="/feedback">
                        <template>
                            <img style="width: 22px;height: 22px;margin-right: 5px" class="personIcon" src="../assets/personIcon/feedback.png">
                            <span>意见反馈</span>
                        </template>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="rightContent" >
                <router-view />
            </div>
        </div>
        <bottom ref="bottom"></bottom>
    </div>
</template>

<script>
import webNav from "@/components/webNav";
import bottom from "@/components/bottom"
import {mapGetters} from "vuex";
import {EventBus} from "@/plugins/EUtils";
export default {
    components:{webNav,bottom},
    name: "personLayout",
    data(){
        return{
            identity_id:'',
            activeName:'/personInfo',
            browserHeight:0
        }
    },
    computed: {
        ...mapGetters([
            'identityId',
        ])
    },
    methods:{
        getIdentityId(value){
            if(value){
                this.identity_id = EUtils.deepClone(value);
            }else{
                this.identity_id = this.identityId
            }
        },
        handleSelect(key, keyPath){
            if(key!=this.activeName){
                this.activeName = key
                this.goRouter(key)
            }
        },
        goRouter(path){
            this.$router.push(path)
        },
        updateBrowserHeight(){
            this.browserHeight = window.innerHeight;
        }
    },
    mounted() {
        let activeName = window.location.pathname
        this.activeName = activeName.replace('/web','')
        this.getIdentityId()
        this.updateBrowserHeight();
        window.addEventListener('resize', this.updateBrowserHeight);
    },
    created() {
        EventBus.$on('identity_id',this.getIdentityId)
    }
}
</script>
<style scoped lang="scss">
.Layout{
    background: #f0f2f5;
    .main-container{
        width: 1100px;
        margin: 20px auto;
        display: flex;
        justify-content: space-between;
        .menuList{
            width: 180px;
            border-radius: 8px;
            background: #fff;
            .el-menu-demo{
                border-radius: 8px;
            }
        }
        .rightContent{
            width: 900px;
            border-radius: 8px;
            background: #fff;
            padding: 20px;
            box-sizing: border-box;
        }
    }
}
</style>
